import { logger } from '../logger';

export const handleApiErrors = (error: unknown) => {
  // ----- Handle expected errors
  if (error instanceof Error) {
    // UI.dialogs.alert(`The ${operationName} has failed. : ${error.message}`);
    logger.error(`${error.message}`);
    logger.error(error);
    return;
  }

  // ----- Handle unexpected errors
  // UI.dialogs.alert(`The ${operationName} has failed.`); // show some error to the user
  logger.error(error); // Log to backend
};
